import { CachedProjectiles, Projectile } from "../utils/projectile";
import AnalyseGrenadesMapViewSVG from "./AnalyseGrenadesMapViewSVG";
import { FireInfo, SmokeInfo } from "./MapView";
import { GrenadeData, PlayerFrameData } from "../utils/types";

interface AnalyseGrenadesMapViewLayerProps {
  playerFrames: PlayerFrameData[],
  players: number[],
  upperView: boolean,
  mapName: string,
  mapOffset: number[],
  mapZoom: number,
  currentTick: number | undefined,
  currentTickRange: number[],
  projectiles: Projectile[],
  projectileCache: CachedProjectiles,
  selectedProjectileCache: CachedProjectiles | undefined,
  hoveredProjectile: number | undefined,
  explosions: GrenadeData[],
  smokes: SmokeInfo[],
  fires: FireInfo[],
  rect: number[] | undefined,
  rectType: 'all' | 'landing' | undefined,
  rectChanged: (
    recordingRect: number[] | undefined,
    rectType: 'all' | 'landing' | undefined,
    dragStart: boolean,
    dragEnd: boolean,
  ) => void,
}

const AnalyseGrenadesMapViewLayer = ({
  playerFrames,
  players,
  upperView,
  mapName,
  mapOffset,
  mapZoom,
  currentTick,
  currentTickRange,
  projectiles,
  projectileCache,
  selectedProjectileCache,
  hoveredProjectile,
  explosions,
  smokes,
  fires,
  rect,
  rectType,
  rectChanged,
}: AnalyseGrenadesMapViewLayerProps) => {
  const lower = <div className={!upperView ? `map-view-image-fullbright` : `map-view-image-dimmed`} style={{ backgroundImage: mapName === 'de_vertigo' || mapName === 'de_nuke' ? `url('${process.env.PUBLIC_URL}/maps/${mapName}_lower.png')` : '' }}></div>
  const upper = <div className={upperView ? `map-view-image-fullbright map-view-shadows` : `map-view-image-dimmed map-view-shadows`} style={{ backgroundImage: `url('${process.env.PUBLIC_URL}/maps/${mapName}.png')` }}></div>

  const backgrounds = upperView ? <>{lower}{upper}</> : <>{upper}{lower}</>;

  return (
    <>
      <div className="map-view-wrapper p-3">
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "100%",
            transform: `translate(${mapOffset[0]}vmin, ${mapOffset[1]}vmin) scale(${mapZoom})`,
          }}
        >          
          <div style={{ position: "absolute", width: "100%", height: "100%" }}>
            {backgrounds}
          </div>
          {currentTick !== undefined ? (
            <div style={{ position: "absolute", width: "100%", height: "100%" }}>
              <AnalyseGrenadesMapViewSVG
                playerFrames={playerFrames}
                players={players}
                upperView={upperView}
                mapName={mapName}
                currentTick={currentTick}
                currentTickRange={currentTickRange}
                projectiles={projectiles}
                projectileCache={projectileCache}
                selectedProjectileCache={selectedProjectileCache}
                hoveredProjectile={hoveredProjectile}
                explosions={explosions}
                smokes={smokes}
                fires={fires}
                mapZoom={mapZoom}
                rect={rect}
                rectType={rectType}
                rectChanged={rectChanged}
              />
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
}


export default AnalyseGrenadesMapViewLayer;